import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
  APP_CONSTANT,
  excelExportSheetheader,
  getAppConstantCategoryValue,
  INDEX_SCORE_INDICATOR,
} from "../../../../utils/constants";

export const exportToExcelV2 = async (
  data,
  fileName = "gap_analysis.xlsx",
  brandHeader,
  excelExportData,
  filter_week,
  end_date,
  frequencyData,
  expData,
  isCustomRecruitCategory = false,
) => {
  const rows = [];

  rows.push(["UseSights Scorecard", "", "", ""]);
  rows.push([
    `Time Period: ${filter_week} Weeks Ending ${end_date}`,
    "",
    "",
    "",
  ]);
  rows.push(["", "", "", ""]);
  rows.push([
    "",
    getAppConstantCategoryValue(isCustomRecruitCategory),
    brandHeader,
    "Index",
  ]);
  if (frequencyData && frequencyData?.length > 0) {
    rows.push([
      "Usage Frequency",
      `(n=${frequencyData[0].categoryBaseSize} products)${frequencyData[0].categoryBaseSize < 35 ? "*" : ""}`,
      `(n=${frequencyData[0].brandBaseSize} products)${frequencyData[0].brandBaseSize < 35 ? "*" : ""}`,
      "",
    ]);
    rows.push([
      frequencyData[0]?.labelTwo,
      frequencyData[0]?.category_avg,
      frequencyData[0].brandVal,
      frequencyData[0].value,
    ]);
    rows.push(["", "", "", ""]);
  }

  // Loop through each key in the object
  for (const key in excelExportData) {
    if (Array.isArray(excelExportData[key])) {
      const datakey = excelExportData[key];
      if (key === "timeOfDayData" || key === "occasionsData") {
        rows.push([
          key === "occasionsData" ? "XMOT® Occasions & Needs" : "When Used",
          `(n=${datakey[0]?.categoryBaseSize} ${key === "occasionsData" ? "XMOT® surveys" : "uses"})${datakey[0]?.categoryBaseSize < 35 ? "*" : ""}`,
          `(n=${datakey[0]?.brandBaseSize} ${key === "occasionsData" ? "XMOT® surveys" : "uses"})${datakey[0]?.brandBaseSize < 35 ? "*" : ""}`,
          "",
        ]);
      }
      rows.push([`${excelExportSheetheader(key)}`, "", "", ""]);

      for (let i = 0; i < datakey.length; i++) {
        const colLabel = datakey[i] ? `${datakey[i].labelTwo}` : "";
        const colCategory = datakey[i] ? datakey[i].category_avg : "";
        const colBrand = datakey[i] ? datakey[i].brandVal : "";
        const colIndexValue = datakey[i] ? datakey[i].value : "";
        rows.push([colLabel, colCategory, colBrand, colIndexValue]);
      }
      rows.push(["", "", "", ""]);
    }
  }

  //Expereince XMOT
  if (expData && expData?.length > 0) {
    rows.push(["XMOT® Experience", "", "", ""]);
    rows.push([
      expData[0]?.labelTwo,
      expData[0]?.category_avg,
      expData[0].brandVal,
      expData[0].value,
    ]);
    rows.push([
      expData[1]?.labelTwo,
      expData[1]?.category_avg,
      expData[1].brandVal,
      expData[1].value,
    ]);
    rows.push(["", "", "", ""]);
  }

  //Bottom part
  rows.push(["*Low sample n<35", "INDEX", "", ""]);
  rows.push(["", ">120", "Strength", ""]);
  rows.push(["Source: UseSights®", "80-120", "Average", ""]);
  rows.push(["", "<80", "Opportunity", ""]);

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Survey Data");

  rows.forEach((rowData, index) => {
    const row = worksheet.addRow(rowData);

    row.eachCell((cell, colNumber) => {
      if (index === 3) {
        cell.font = { bold: true };
      }

      if (colNumber === 4) {
        const colValue = rowData[3];
        if (
          rowData[0] !== "" &&
          colValue > INDEX_SCORE_INDICATOR.GREEN_TEXT_VALUE
        ) {
          cell.font = { color: { argb: "196b24" }, bold: true };
        } else if (
          rowData[0] !== "" &&
          colValue < INDEX_SCORE_INDICATOR.RED_TEXT_VALUE
        ) {
          cell.font = { color: { argb: "9c0006" }, bold: true };
        } else {
          cell.font = { bold: true };
        }
        cell.alignment = {
          wrapText: true,
          vertical: "bottom",
          horizontal: "center",
        };
      } else {
        cell.alignment = {
          wrapText: true,
          vertical: "bottom",
          horizontal: "center",
        };
      }

      if (colNumber === 1) {
        cell.alignment = {
          wrapText: true,
          vertical: "bottom",
          horizontal: "left",
        };
      }

      // Check for "Base Size (Uses)" in the first cell
      if (
        rowData[0] === "UseSights Scorecard" ||
        rowData[0] === "Usage Frequency" ||
        rowData[0] === "When Used" ||
        rowData[0] === "XMOT® Occasions & Needs" ||
        rowData[0] === "XMOT® Experience"
      ) {
        if (colNumber === 1) {
          cell.font = { bold: true };
        }
      }

      if (rowData[0] === "*Low sample n<35") {
        if (colNumber === 1) {
          cell.font = { italic: true };
        }
      }

      if (rowData[1] === "INDEX") {
        if (colNumber === 2 || colNumber === 3) {
          cell.font = { bold: true };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
      }

      if (rowData[1] === ">120") {
        if (colNumber === 2 || colNumber === 3) {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
      }

      if (rowData[1] === "80-120") {
        if (colNumber === 2 || colNumber === 3) {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
      }

      if (rowData[1] === "<80") {
        if (colNumber === 2 || colNumber === 3) {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
      }

      if (rowData[2] === "Strength") {
        if (colNumber === 3) {
          cell.font = { color: { argb: "196b24" } };
        }
      }

      if (rowData[2] === "Opportunity") {
        if (colNumber === 3) {
          cell.font = { color: { argb: "9c0006" } };
        }
      }
    });

    // Optional: set row height for better visibility
    // row.height = 30;
  });

  worksheet.columns = [
    { width: 50 },
    { width: 30 },
    { width: 30 },
    { width: 10 },
  ];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, fileName);
};
